import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata} from '../../../../../../utils/builderMetadata'

export type TextStylesParams = {
  textBreadcrumbsFont: StyleParamType.Font
  textBreadcrumbsColor: StyleParamType.Color
  textExperienceNameFont: StyleParamType.Font
  textExperienceNameColor: StyleParamType.Color
  textExperienceSummaryFont: StyleParamType.Font
  textExperienceSummaryColor: StyleParamType.Color
  textExperienceDetailsFont: StyleParamType.Font
  textExperienceDetailsColor: StyleParamType.Color
  textAboutSectionTitleFont: StyleParamType.Font
  textAboutSectionTitleColor: StyleParamType.Color
  textAboutSectionFont: StyleParamType.Font
  textAboutSectionColor: StyleParamType.Color
  textReservationSectionTitleFont: StyleParamType.Font
  textReservationSectionTitleColor: StyleParamType.Color
  textReservationSectionBodyFont: StyleParamType.Font
  textReservationSectionBodyColor: StyleParamType.Color
}

export const textStylesParams = createStylesParams<TextStylesParams>({
  textBreadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textBreadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textExperienceNameFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: params.isMobile ? 28 : 48,
      })(params),
    metadata: fontMetadata('Page-title', 48, 28),
  },
  textExperienceNameColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
    metadata: colorMetadata(StyleType.color, 'color-title'),
  },
  textExperienceSummaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) => wixFontParam('Body-M', {size: params.isMobile ? 16 : 20})(params),
    metadata: fontMetadata('Body-M', 20, 16),
  },
  textExperienceSummaryColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textExperienceDetailsFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) => wixFontParam('Body-M', {size: params.isMobile ? 14 : 16})(params),
    metadata: fontMetadata('Body-M', 16, 14),
  },
  textExperienceDetailsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textAboutSectionTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', {htmlTag: 'h2', size: 28, weight: '400'}),
    metadata: fontMetadata('Heading-M', 28),
  },
  textAboutSectionTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textAboutSectionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textAboutSectionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textReservationSectionTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', {htmlTag: 'h2', size: 28, weight: '400'}),
    metadata: fontMetadata('Heading-M', 28),
  },
  textReservationSectionTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
  textReservationSectionBodyFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  textReservationSectionBodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-text-primary'),
    metadata: colorMetadata(StyleType.color, 'color-text-primary'),
  },
})
